import { CIcon } from '~/icons/types'

export const ciCatamaran: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M20.96 16.919a.85.85 0 0 0-.635-.285h-3.243l-.449-2.626-.107-.627-.119-.7a1.922 1.922 0 0 0-1.9-1.6H12.39v-.985h3.132a.5.5 0 0 0 .388-.816 17.651 17.651 0 0 1-3.52-7.4V1.5a.5.5 0 0 0-1 0v9.581H9.67a1.923 1.923 0 0 0-1.9 1.6l-.119.7-.107.627-.449 2.626H3.853a.852.852 0 0 0-.847.947 17.866 17.866 0 0 0 1.667 5.688.829.829 0 0 0 .745.47h.464a.827.827 0 0 0 .826-.825v-3.027h3.4a.846.846 0 0 1 .633.285l.253.285a1.068 1.068 0 0 0 .793.355h.6a1.068 1.068 0 0 0 .793-.356l.252-.284a.846.846 0 0 1 .634-.285h3.4v3.027a.827.827 0 0 0 .825.825h.464a.827.827 0 0 0 .744-.468 18.468 18.468 0 0 0 1.248-3.408l.006-.023.322-1.569c.036-.23.067-.46.093-.691a.842.842 0 0 0-.208-.661Zm-6.456-7.821H12.39V5.274a18.662 18.662 0 0 0 2.115 3.824Zm1.246 5.68h-1.815v-.813h1.676l.087.512.052.301Zm-4.464 0v-.813h1.65v.813h-1.65Zm-2.858 0 .052-.3.087-.512h1.722v.813l-1.86-.001Zm1.242-2.7h4.838a.923.923 0 0 1 .912.769l.02.113h-6.7l.02-.113a.925.925 0 0 1 .91-.766v-.003Zm-1.413 3.7h7.664l.146.856H8.111l.146-.856Zm-2.549 6.961H5.53a16.88 16.88 0 0 1-1.509-5.1h1.688v5.1Zm8.361-3.852a1.852 1.852 0 0 0-1.382.621l-.3.3-.647-.02-.252-.284a1.847 1.847 0 0 0-1.38-.621h-3.4V17.63H17.47v1.253l-3.4.004Zm6.025-.794-.314 1.534a17.59 17.59 0 0 1-1.13 3.112h-.18v-5.1h1.69c-.02.154-.043.31-.066.454Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'catamaran',
  type: 'thin'
}
